<template>
  <custom-refinement-list attribute="offers.name" :sort-by="sortBy" />
</template>

<script>
import CustomRefinementList from './CustomRefinementList.vue';

export default {
  components: {
    CustomRefinementList,
  },
  methods: {
    sortBy(a, b) {
      return b.label - a.label;
    },
  },
};
</script>
